"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionOnFocusCompact = exports.positionOnFocusComfortable = exports.positionOnFocusDefault = exports.leftPositionOnFocus = exports.inputLabelTransformCompact = exports.inputLabelTransformComfortable = exports.inputLabelTransformDefault = exports.inputLabelShrink = exports.inputLabelReadOnly = exports.inputLabelDisabled = exports.inputLabelHover = exports.inputLabelFocused = exports.inputLabelCompactDensity = exports.inputLabelComfortableDensity = exports.inputLabelDefaultDensity = exports.inputLabelBase = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts");

const DEFAULT_LEFT_POSITION = 13;
const DEFAULT_TOP_POSITION = 20;
const COMFORTABLE_TOP_POSITION = 11;
const COMPACT_TOP_POSITION = 8;

const inputLabelBase = ({
  theme
}) => (0, _stylitas.css)`
  z-index: 1;
  display: block;
  position: absolute;
  left: ${DEFAULT_LEFT_POSITION}px;
  pointer-events: none;
  transition: transform 0.15s ease-out, background-color 0.15s ease-out,
    color 0.3s ease-out;
  transform-origin: 0;
  line-height: 1em;
  padding: 0 4px;
  color: ${_stylitas.utilities.palette.color(theme, 'neutral06')};
`;

exports.inputLabelBase = inputLabelBase;

const inputLabelTransformDefault = ({
  labelShrink,
  size
}) => labelShrink && size === 'default' && (0, _stylitas.css)`
    transform: scale(1) translate(0, -27px);
  `;

exports.inputLabelTransformDefault = inputLabelTransformDefault;

const inputLabelTransformComfortable = ({
  labelShrink,
  size
}) => labelShrink && size === 'comfortable' && (0, _stylitas.css)`
    transform: scale(1) translate(0, -18px);
  `;

exports.inputLabelTransformComfortable = inputLabelTransformComfortable;

const inputLabelTransformCompact = ({
  labelShrink,
  size
}) => labelShrink && size === 'compact' && (0, _stylitas.css)`
    transform: scale(1) translate(0, -15px);
  `;

exports.inputLabelTransformCompact = inputLabelTransformCompact;

const inputLabelDisabled = ({
  theme,
  disabled
}) => disabled && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral04')};
  `;

exports.inputLabelDisabled = inputLabelDisabled;

const inputLabelReadOnly = ({
  theme,
  readOnly
}) => readOnly && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral06')};
  `;

exports.inputLabelReadOnly = inputLabelReadOnly;

const inputLabelDefaultDensity = ({
  size
}) => size === 'default' && (0, _stylitas.css)`
    top: ${DEFAULT_TOP_POSITION}px;
  `;

exports.inputLabelDefaultDensity = inputLabelDefaultDensity;

const inputLabelComfortableDensity = ({
  size
}) => size === 'comfortable' && (0, _stylitas.css)`
    top: ${COMFORTABLE_TOP_POSITION}px;
  `;

exports.inputLabelComfortableDensity = inputLabelComfortableDensity;

const inputLabelCompactDensity = ({
  size
}) => size === 'compact' && (0, _stylitas.css)`
    top: ${COMPACT_TOP_POSITION}px;
  `;

exports.inputLabelCompactDensity = inputLabelCompactDensity;

const inputLabelFocused = ({
  theme,
  inputFocus,
  variant
}) => inputFocus && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'secondary05')};
    ${variant && `color: ${_stylitas.utilities.palette.color(theme, variant)};`}
  `;

exports.inputLabelFocused = inputLabelFocused;

const leftPositionOnFocus = ({
  inputFocus,
  readOnly
}) => inputFocus && !readOnly && (0, _stylitas.css)`
    left: ${DEFAULT_LEFT_POSITION - _consts.FOCUSED_BORDER_DELTA}px;
  `;

exports.leftPositionOnFocus = leftPositionOnFocus;

const positionOnFocusDefault = ({
  size,
  inputFocus,
  readOnly
}) => inputFocus && !readOnly && size === 'default' && (0, _stylitas.css)`
    top: ${DEFAULT_TOP_POSITION - _consts.FOCUSED_BORDER_DELTA}px;
  `;

exports.positionOnFocusDefault = positionOnFocusDefault;

const positionOnFocusComfortable = ({
  size,
  inputFocus,
  readOnly
}) => inputFocus && !readOnly && size === 'comfortable' && (0, _stylitas.css)`
    top: ${COMFORTABLE_TOP_POSITION - _consts.FOCUSED_BORDER_DELTA}px;
  `;

exports.positionOnFocusComfortable = positionOnFocusComfortable;

const positionOnFocusCompact = ({
  size,
  inputFocus,
  readOnly
}) => inputFocus && !readOnly && size === 'compact' && (0, _stylitas.css)`
    top: ${COMPACT_TOP_POSITION - _consts.FOCUSED_BORDER_DELTA}px;
  `;

exports.positionOnFocusCompact = positionOnFocusCompact;

const inputLabelHover = ({
  theme,
  inputHover,
  inputFocus,
  disabled
}) => inputHover && !inputFocus && !disabled && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  `;

exports.inputLabelHover = inputLabelHover;

const inputLabelShrink = ({
  theme,
  labelShrink,
  variant,
  inputBackground = '#fff'
}) => labelShrink && (0, _stylitas.css)`
    font-weight: 600;
    font-size: 12px;
    background-color: ${inputBackground};
    ${variant && `color: ${_stylitas.utilities.palette.color(theme, variant)};`}
  `;

exports.inputLabelShrink = inputLabelShrink;